import Api from "@/services/api";
import { UserActivityLogFilter, UserActivityLogResult } from "@/services/userActivityLogs/types";

export async function getUserActivityLogs(filter: UserActivityLogFilter): Promise<UserActivityLogResult> {
    return new Promise((resolve, reject) => {
        Api.post("/ActivityLog/users", filter).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function getEtityTypes(): Promise<Array<string>> {
    return new Promise((resolve, reject) => {
        Api.get("/ActivityLog/entitytypes").then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}
